webpackJsonp([169310805621404],{

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n        flex-direction: column;\n        align-items: center;\n        padding-left: 0;\n        padding-right: 0;\n        padding-bottom: 0;\n    "], ["\n        flex-direction: column;\n        align-items: center;\n        padding-left: 0;\n        padding-right: 0;\n        padding-bottom: 0;\n    "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n        padding-top: 0;\n    "], ["\n        padding-top: 0;\n    "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n        top: calc(", "px + 10rem);\n    "], ["\n        top: calc(", "px + 10rem);\n    "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n        order: 1;\n        align-self: initial;\n        top: initial;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        box-sizing: border-box;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        height: 70px;\n        border-top: 1px solid rgba(0, 0, 0, 0.08);\n        background: ", ";\n    "], ["\n        order: 1;\n        align-self: initial;\n        top: initial;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        box-sizing: border-box;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        height: 70px;\n        border-top: 1px solid rgba(0, 0, 0, 0.08);\n        background: ", ";\n    "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n        justify-content: flex-start;\n        align-items: initial;\n        overflow-x: auto;\n        overflow-y: hidden;\n        height: auto;\n        padding: 20px 0;\n        padding-bottom: calc(20px + env(safe-area-inset-bottom));\n    "], ["\n        justify-content: flex-start;\n        align-items: initial;\n        overflow-x: auto;\n        overflow-y: hidden;\n        height: auto;\n        padding: 20px 0;\n        padding-bottom: calc(20px + env(safe-area-inset-bottom));\n    "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n            font-size: 12px;\n            line-height: 12px;\n        "], ["\n            font-size: 12px;\n            line-height: 12px;\n        "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n            &:not(:first-child) {\n                margin-left: 5rem;\n            }\n        "], ["\n            &:not(:first-child) {\n                margin-left: 5rem;\n            }\n        "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n            &:first-child {\n                margin-left: auto;\n                padding-left: 40px;\n            }\n            &:last-child {\n                margin-right: auto;\n                padding-right: 40px;\n            }\n        "], ["\n            &:first-child {\n                margin-left: auto;\n                padding-left: 40px;\n            }\n            &:last-child {\n                margin-right: auto;\n                padding-right: 40px;\n            }\n        "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n            display: flex;\n        "], ["\n            display: flex;\n        "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n        transform: none;\n        padding-bottom: 5rem;\n        min-height: calc(100vh - 150px);\n    "], ["\n        transform: none;\n        padding-bottom: 5rem;\n        min-height: calc(100vh - 150px);\n    "]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n        margin: 0;\n        min-height: calc(100vh - 160px);\n\t"], ["\n        margin: 0;\n        min-height: calc(100vh - 160px);\n\t"]),
	    _templateObject12 = _taggedTemplateLiteralLoose(["\n            margin: 0;\n            flex-direction: column;\n        "], ["\n            margin: 0;\n            flex-direction: column;\n        "]),
	    _templateObject13 = _taggedTemplateLiteralLoose(["\n                font-size: 10.5px;\n                line-height: 12px;\n            "], ["\n                font-size: 10.5px;\n                line-height: 12px;\n            "]),
	    _templateObject14 = _taggedTemplateLiteralLoose(["\n            display: none;\n        "], ["\n            display: none;\n        "]),
	    _templateObject15 = _taggedTemplateLiteralLoose(["\n    .article {\n        display: flex;\n        margin-bottom: 5rem;\n        padding-left: 2.5rem;\n        padding-right: 2.5rem;\n        box-sizing: border-box;\n\n        &:hover {\n            cursor: pointer;\n        }\n\n        /* Listing artwork is a composite: a white band with the publication's\n           logo left-aligned, above the photograph. 108 of 109 sources are\n           1200x800, so cover crops nothing meaningful and \u2014 unlike contain \u2014\n           keeps the logo at a constant position across every card. The lone\n           portrait source letterboxed under contain, which is what made its\n           logo look shifted. */\n        &.medium,\n        &.large {\n            flex-direction: column;\n\n            ", " {\n                width: 100%;\n                height: 0;\n                background-color: ", ";\n                background-size: cover;\n                background-position: center center;\n            }\n\n            ", " {\n                padding: 3rem;\n                min-height: 110px;\n                box-sizing: border-box;\n            }\n        }\n\n        /* Half-width cards, 3:2 to match the source artwork. */\n        &.medium {\n            flex: 0 1 50%;\n\n            ", " {\n                padding-bottom: 66.67%;\n            }\n        }\n\n        /* Featured articles (is_featured_format in WP) run full width as a\n           two-column card: artwork on the left, title on the right. The info\n           panel is white so it reads as one continuous card with the white\n           logo band along the top of the artwork. */\n        &.large {\n            flex: 0 1 100%;\n            flex-direction: row;\n            align-items: stretch;\n\n            ", " {\n                flex: 0 0 48%;\n                width: auto;\n                /* 48% column at the artwork's native 3:2 \u2192 48 * (2/3) = 32%.\n                   Percentage padding resolves against the card width, so this\n                   keeps the source uncropped. */\n                padding-bottom: 32%;\n            }\n\n            ", " {\n                flex: 1 1 52%;\n                background-color: #FFFFFF;\n                justify-content: flex-start;\n                padding: 5rem;\n\n                ", "\n            }\n\n            ", " {\n                font-size: 30px;\n                line-height: 38px;\n                /* Roomier than the 2-line clamp the half-width cards use. */\n                -webkit-line-clamp: 4;\n\n                ", "\n            }\n\n            /* Stack below desktop \u2014 the two columns get too narrow to read. */\n            ", "\n        }\n\n\n        /* mobile: full-width stacked cards, still with a uniform image ratio */\n        ", "\n    }\n"], ["\n    .article {\n        display: flex;\n        margin-bottom: 5rem;\n        padding-left: 2.5rem;\n        padding-right: 2.5rem;\n        box-sizing: border-box;\n\n        &:hover {\n            cursor: pointer;\n        }\n\n        /* Listing artwork is a composite: a white band with the publication's\n           logo left-aligned, above the photograph. 108 of 109 sources are\n           1200x800, so cover crops nothing meaningful and \u2014 unlike contain \u2014\n           keeps the logo at a constant position across every card. The lone\n           portrait source letterboxed under contain, which is what made its\n           logo look shifted. */\n        &.medium,\n        &.large {\n            flex-direction: column;\n\n            ", " {\n                width: 100%;\n                height: 0;\n                background-color: ", ";\n                background-size: cover;\n                background-position: center center;\n            }\n\n            ", " {\n                padding: 3rem;\n                min-height: 110px;\n                box-sizing: border-box;\n            }\n        }\n\n        /* Half-width cards, 3:2 to match the source artwork. */\n        &.medium {\n            flex: 0 1 50%;\n\n            ", " {\n                padding-bottom: 66.67%;\n            }\n        }\n\n        /* Featured articles (is_featured_format in WP) run full width as a\n           two-column card: artwork on the left, title on the right. The info\n           panel is white so it reads as one continuous card with the white\n           logo band along the top of the artwork. */\n        &.large {\n            flex: 0 1 100%;\n            flex-direction: row;\n            align-items: stretch;\n\n            ", " {\n                flex: 0 0 48%;\n                width: auto;\n                /* 48% column at the artwork's native 3:2 \u2192 48 * (2/3) = 32%.\n                   Percentage padding resolves against the card width, so this\n                   keeps the source uncropped. */\n                padding-bottom: 32%;\n            }\n\n            ", " {\n                flex: 1 1 52%;\n                background-color: #FFFFFF;\n                justify-content: flex-start;\n                padding: 5rem;\n\n                ", "\n            }\n\n            ", " {\n                font-size: 30px;\n                line-height: 38px;\n                /* Roomier than the 2-line clamp the half-width cards use. */\n                -webkit-line-clamp: 4;\n\n                ", "\n            }\n\n            /* Stack below desktop \u2014 the two columns get too narrow to read. */\n            ", "\n        }\n\n\n        /* mobile: full-width stacked cards, still with a uniform image ratio */\n        ", "\n    }\n"]),
	    _templateObject16 = _taggedTemplateLiteralLoose(["\n                    padding: 4rem;\n                "], ["\n                    padding: 4rem;\n                "]),
	    _templateObject17 = _taggedTemplateLiteralLoose(["\n                    font-size: 23px;\n                    line-height: 29px;\n                "], ["\n                    font-size: 23px;\n                    line-height: 29px;\n                "]),
	    _templateObject18 = _taggedTemplateLiteralLoose(["\n                flex-direction: column;\n\n                ", " {\n                    flex: none;\n                    width: 100%;\n                    padding-bottom: 66.67%;\n                }\n\n                ", " {\n                    flex: none;\n                    padding: 3rem;\n                }\n\n                ", " {\n                    font-size: 22px;\n                    line-height: 26px;\n                }\n            "], ["\n                flex-direction: column;\n\n                ", " {\n                    flex: none;\n                    width: 100%;\n                    padding-bottom: 66.67%;\n                }\n\n                ", " {\n                    flex: none;\n                    padding: 3rem;\n                }\n\n                ", " {\n                    font-size: 22px;\n                    line-height: 26px;\n                }\n            "]),
	    _templateObject19 = _taggedTemplateLiteralLoose(["\n            flex: none !important;\n            flex-direction: column;\n            padding-left: 0;\n            padding-right: 0;\n\n            ", " {\n                height: 0 !important;\n                padding-bottom: 66% !important;\n            }\n\n            ", " {\n                padding: 2rem 3rem 3rem;\n                min-height: 90px;\n            }\n        "], ["\n            flex: none !important;\n            flex-direction: column;\n            padding-left: 0;\n            padding-right: 0;\n\n            ", " {\n                height: 0 !important;\n                padding-bottom: 66% !important;\n            }\n\n            ", " {\n                padding: 2rem 3rem 3rem;\n                min-height: 90px;\n            }\n        "]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(29);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(27);
	
	var _polished = __webpack_require__(12);
	
	var _moment = __webpack_require__(61);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _components = __webpack_require__(11);
	
	var _settings = __webpack_require__(32);
	
	var _themes = __webpack_require__(15);
	
	var _global = __webpack_require__(5);
	
	var _type = __webpack_require__(10);
	
	var _utils = __webpack_require__(4);
	
	var _colors = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Journal = function (_Component) {
	    _inherits(Journal, _Component);
	
	    function Journal() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Journal);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            data: [],
	            activeCategory: 'all'
	        }, _this.componentWillMount = function () {
	            var _this$props = _this.props,
	                updateSettings = _this$props.updateSettings,
	                fetchSettings = _this$props.fetchSettings;
	
	            fetchSettings();
	
	            _this.setState({
	                data: _this.props.data.wordpressJournal,
	                activeCategory: _this.props.pathContext.section || 'all'
	            });
	
	            updateSettings({
	                theme: {
	                    text: '#595850',
	                    background: _colors.pageBackground
	                }
	            });
	        }, _this.renderCatNav = function () {
	            var _this$state = _this.state,
	                data = _this$state.data,
	                activeCategory = _this$state.activeCategory;
	
	
	            if (data.cats) {
	                var cats = data.cats.map(function (cat, i) {
	                    return _react2.default.createElement(
	                        CatLink,
	                        {
	                            key: i,
	                            to: "/journal/section/" + cat.slug,
	                            selected: activeCategory == cat.slug
	                        },
	                        cat.title
	                    );
	                });
	
	                return _react2.default.createElement(
	                    CatNav,
	                    null,
	                    _react2.default.createElement(
	                        Heading,
	                        null,
	                        "Filter:\xA0"
	                    ),
	                    _react2.default.createElement(
	                        CatLink,
	                        {
	                            to: "/journal",
	                            selected: activeCategory == 'all'
	                        },
	                        "All"
	                    ),
	                    cats
	                );
	            }
	        }, _this.getArticles = function () {
	            var _this$state2 = _this.state,
	                data = _this$state2.data,
	                activeCategory = _this$state2.activeCategory;
	
	
	            if (!data.articles) return;
	
	            if (activeCategory !== 'all') {
	                return (0, _lodash.filter)(data.articles, { catSlug: activeCategory });
	            } else {
	                return data.articles;
	            }
	        }, _this.renderArticles = function () {
	            var _this$state3 = _this.state,
	                data = _this$state3.data,
	                activeCategory = _this$state3.activeCategory;
	
	            var articles = _this.getArticles();
	
	            if (articles) {
	                var items = articles.map(function (article, i) {
	                    var acf = JSON.parse(article.acf_json);
	
	                    var isLarge = acf.is_featured_format;
	                    if (isLarge === undefined) isLarge = false;
	                    // if(i % 6 == 0) isLarge = true; //every 6th is large format
	
	                    return _react2.default.createElement(
	                        "div",
	                        {
	                            className: "article " + (isLarge ? 'large' : 'medium'),
	                            key: i,
	                            onClick: function onClick() {
	                                return (0, _gatsbyLink.navigateTo)("/journal/" + article.slug);
	                            }
	                        },
	                        _react2.default.createElement(ListImageLink, {
	                            image: acf.hero_image_listing.sizes.large,
	                            to: "/journal/" + article.slug
	                        }),
	                        _react2.default.createElement(
	                            Info,
	                            null,
	                            _react2.default.createElement(
	                                TitleLink,
	                                {
	                                    to: "/journal/" + article.slug
	                                },
	                                article.title
	                            ),
	                            _react2.default.createElement(
	                                Meta,
	                                null,
	                                _react2.default.createElement(
	                                    Category,
	                                    null,
	                                    article.catTitle
	                                )
	                            ),
	                            isLarge && acf.listing_description && _react2.default.createElement(Description, {
	                                dangerouslySetInnerHTML: { __html: acf.listing_description }
	                            })
	                        )
	                    );
	                });
	
	                return _react2.default.createElement(
	                    Articles,
	                    null,
	                    _react2.default.createElement(
	                        Container,
	                        null,
	                        items
	                    )
	                );
	            }
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Journal.prototype.render = function render() {
	        var splashActive = this.props.settings.splashActive;
	        var data = this.state.data;
	
	
	        var firstPostACF = void 0;
	
	        if (data.articles) {
	            firstPostACF = JSON.parse(data.articles[0].acf_json);
	        }
	
	        return _react2.default.createElement(
	            Wrapper,
	            {
	                active: splashActive == false
	            },
	            data && _react2.default.createElement(_components.MetaTags, {
	                title: "Paul Conrad Architects \u2014 Journal",
	                description: firstPostACF.meta_description,
	                url: "https://www.conradarchitects.com/journal",
	                image: firstPostACF.hero_image.sizes.medium2
	            }),
	            this.renderArticles(),
	            this.renderCatNav()
	        );
	    };
	
	    return Journal;
	}(_react.Component);
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	    displayName: "Journal__Wrapper",
	    componentId: "sc-7nv4no-0"
	})(["display:flex;flex-direction:row;width:100%;z-index:2;box-sizing:border-box;transition:all 0.75s ease;transition-delay:0.4s;will-change:transform;transform:translateY(100px);opacity:0;padding-top:10rem;", " ", " ", ""], _utils.media.tablet(_templateObject), _utils.media.phone(_templateObject2), function (props) {
	    if (props.active) return (0, _styledComponents.css)(["transform:translateY(0);opacity:1;"]);
	});
	
	// category navigation
	var Heading = _styledComponents2.default.div.withConfig({
	    displayName: "Journal__Heading",
	    componentId: "sc-7nv4no-1"
	})([""]);
	var CatLink = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	    displayName: "Journal__CatLink",
	    componentId: "sc-7nv4no-2"
	})(["", ""], function (props) {
	    if (props.selected) return (0, _styledComponents.css)(["opacity:1!important;"]);
	});
	var CatNav = _styledComponents2.default.div.withConfig({
	    displayName: "Journal__CatNav",
	    componentId: "sc-7nv4no-3"
	})(["order:-1;align-self:flex-start;position:sticky;top:calc(", "px + 10rem);display:flex;flex-direction:column;width:180px;", " ", " ", " ", ",", "{", ";text-indent:0!important;margin-bottom:1rem;opacity:0.5;", " ", " ", "}", "{}", "{display:none;", "}"], _global.headerHeight.desktop, _utils.media.laptop(_templateObject3, _global.headerHeight.laptop), _utils.media.tablet(_templateObject4, _colors.pageBackground), _utils.media.phone(_templateObject5), Heading, CatLink, _type.caption, _utils.media.laptop(_templateObject6), _utils.media.tablet(_templateObject7), _utils.media.phone(_templateObject8), CatLink, Heading, _utils.media.tablet(_templateObject9));
	
	// articles listing
	var Container = _styledComponents2.default.div.withConfig({
	    displayName: "Journal__Container",
	    componentId: "sc-7nv4no-4"
	})([""]);
	var Articles = _styledComponents2.default.div.withConfig({
	    displayName: "Journal__Articles",
	    componentId: "sc-7nv4no-5"
	})(["min-height:100vh;", ";margin-left:auto;margin-right:auto;", " ", " ", "{display:flex;flex-flow:row wrap;margin-left:-2.5rem;margin-right:-2.5rem;", "}"], _global.innerContainer, _utils.media.tablet(_templateObject10), _utils.media.phone(_templateObject11), Container, _utils.media.phone(_templateObject12));
	
	var ListImageLink = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	    displayName: "Journal__ListImageLink",
	    componentId: "sc-7nv4no-6"
	})(["background-image:url(", ");", ""], function (props) {
	    return props.image;
	}, _global.bgImage);
	
	// article type styles
	
	var TitleLink = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	    displayName: "Journal__TitleLink",
	    componentId: "sc-7nv4no-7"
	})(["display:block;", ";", ";display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"], _type.projectIntro, _global.hoverState);
	var Category = _styledComponents2.default.div.withConfig({
	    displayName: "Journal__Category",
	    componentId: "sc-7nv4no-8"
	})([""]);
	var Date = _styledComponents2.default.div.withConfig({
	    displayName: "Journal__Date",
	    componentId: "sc-7nv4no-9"
	})([""]);
	var Description = _styledComponents2.default.div.withConfig({
	    displayName: "Journal__Description",
	    componentId: "sc-7nv4no-10"
	})([""]);
	var Meta = _styledComponents2.default.div.withConfig({
	    displayName: "Journal__Meta",
	    componentId: "sc-7nv4no-11"
	})(["display:flex;margin-top:1rem;> *:nth-child(2){margin-left:3px;}"]);
	
	var Info = _styledComponents2.default.div.withConfig({
	    displayName: "Journal__Info",
	    componentId: "sc-7nv4no-12"
	})(["background-color:#FFFFFF;display:flex;flex-direction:column;", ",", ",", "{&,*{font-family:'Scto';font-size:14px;line-height:16px;color:#999999;", "}}", "{margin-top:auto;", "}"], Category, Date, Description, _utils.media.laptop(_templateObject13), Description, _utils.media.phone(_templateObject14));
	
	(0, _styledComponents.injectGlobal)(_templateObject15, ListImageLink, _colors.pageBackground, Info, ListImageLink, ListImageLink, Info, _utils.media.laptop(_templateObject16), TitleLink, _utils.media.laptop(_templateObject17), _utils.media.tablet(_templateObject18, ListImageLink, Info, TitleLink), _utils.media.phone(_templateObject19, ListImageLink, Info));
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        fetchSettings: function fetchSettings() {
	            dispatch((0, _settings.fetchSettings)());
	        },
	        updateSettings: function updateSettings(setting) {
	            dispatch((0, _settings.updateSettings)(setting));
	        }
	    };
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	    return {
	        settings: state.settings.settings
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Journal);
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-journal-js-f24f441f97c2d86b13f1.js